export default "__VITE_ASSET__CchQHJG$__"